<template>
    <el-dialog
        class="export-order"
        :visible.sync="generateVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="600px"
        :title="dialogTitle"
        :lock-scroll="false"
        :modal-append-to-body="false"
        append-to-body
    >
        <div class="file_download">
            <div class="label">File download</div>
            <div class="value">
                <span
                    class="file_name"
                    :class="{ generated: label != 'Generating' }"
                    @click="downloadFile"
                    >{{ label }}</span
                >
                <span class="ball-rotate" v-show="isGenerating"></span>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" @click="generateVisible = false"
                >Close</el-button
            >
        </span>
    </el-dialog>
</template>

<script>
import { cmofferApi } from "@/http/cmofferApi.js";
export default {
    data() {
        return {
            timer: "",
            label: "Generating",
            isGenerating: false,
            fileId: "",
        };
    },
    methods: {
        closeDialog() {
            clearInterval(this.timer);
            this.label = "Generating";
            this.fileId = "";
            this.timer = "";
            this.$emit("update:generateVisible", false);
        },
        downloadFile() {
            if (!this.fileId) {
                return;
            }
            window.location.href = `${cmofferApi.orderDownload_url}/${this.fileId}`;
        },
        orderMyDownload() {
            cmofferApi
                .orderMyDownload(
                    {
                        is_real: 1,
                    },
                    "get"
                )
                .then((res) => {
                    if (res.data) {
                        if (Object.keys(res.data).length > 0) {
                            this.isGenerating = false;
                            this.label = res.data.file;
                            this.fileId = res.data.id;
                            clearInterval(this.timer);
                        }
                    }
                });
        },
    },
    props: {
        generateVisible: Boolean,
        dialogTitle: {
          type: String,
          default: "Export",
        },
    },
    watch: {
        generateVisible(val) {
            if (val) {
                this.isGenerating = true;
                this.timer = setInterval(() => {
                    this.orderMyDownload();
                }, 5000);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.file_download {
    padding: 20px;
    display: flex;
    align-items: center;
    .label {
        font-weight: 600;
    }
    .value {
        margin: 0 0 0 20px;
        color: $color-primary-blue;
        .file_name {
            user-select: none;
            margin-right: 20px;
        }
        .generated {
            user-select: all;
            cursor: pointer;
            text-decoration: underline;
        }
        .ball-rotate {
            display: inline-block;
            position: relative;
            width: 6px;
            height: 6px;
            animation: ball-rotate 1s 0s cubic-bezier(0.7, -0.13, 0.22, 0.86)
                infinite;
            border-radius: 100%;
            background-color: $color-primary-blue;
            -webkit-animation-fill-mode: both;
            animation-fill-mode: both;
            &::after,
            &::before {
                position: absolute;
                top: 0;
                width: 100%;
                height: 100%;
                // margin: 2px;
                content: "";
                opacity: 0.8;
                border-radius: 100%;
                background-color: $color-primary-blue;
            }
            &::after {
                left: 14px;
            }
            &::before {
                left: -14px;
            }
        }

        @keyframes ball-rotate {
            0% {
                -webkit-transform: rotate(0) scale(1);
                -ms-transform: rotate(0) scale(1);
                -o-transform: rotate(0) scale(1);
                transform: rotate(0) scale(1);
            }
            50% {
                -webkit-transform: rotate(180deg) scale(0.7);
                -ms-transform: rotate(180deg) scale(0.7);
                -o-transform: rotate(180deg) scale(0.7);
                transform: rotate(180deg) scale(0.7);
            }
            100% {
                -webkit-transform: rotate(360deg) scale(1);
                -ms-transform: rotate(360deg) scale(1);
                -o-transform: rotate(360deg) scale(1);
                transform: rotate(360deg) scale(1);
            }
        }
    }
}
</style>

